import AnalyticsAbstract from "@MAIN/modules/Analytics/Abstract";
import Cookies from "js-cookie";

export default class Yandex extends AnalyticsAbstract {
  constructor() {
    super()

    window.ym = window.ym || function () {
      (window.ym.a = window.ym.a || []).push(arguments)
    }
    window.ym.l = 1 * new Date()
    window.dataLayer = window.dataLayer || []

    this.yandexMetrikaID = process.env.MIX_YANDEX_METRIKA_ID

    let cookieTime = 'ftimevst'
    let firstVisitTime = parseInt(Cookies.get(cookieTime))
    if (!firstVisitTime)
    {
      firstVisitTime = parseInt((new Date()).getTime() / 1000)
      Cookies.set(cookieTime, firstVisitTime, { expires: 90, path: '/' })
    }

    function getSecondsFromFirstVisit() {
      return parseInt((new Date()).getTime() / 1000) - firstVisitTime
    }

    const timeGoals = [
      {
        cookieName : `${cookieTime}_time_left`,
        timeInSeconds: 90,
        goal: 'time_left'
      },
      {
        cookieName : `${cookieTime}_time_left10min`,
        timeInSeconds: 600,
        goal: 'time_left10min'
      },
    ]

    timeGoals.forEach(timeGoal => {
      if (!Cookies.get(timeGoal.cookieName))
      {
        const interval = setInterval(() => {
          if (getSecondsFromFirstVisit() > timeGoal.timeInSeconds) {
            clearInterval(interval)
            window.ym(this.yandexMetrikaID, 'reachGoal', timeGoal.goal)
            Cookies.set(timeGoal.cookieName, 1, { expires: 14, path: '/' })
          }
        }, 1000)
      }
    })
  }

  getClientIdPromise() {
    return new Promise(resolve => {
      window.ym(this.yandexMetrikaID, 'getClientID', clientID => resolve(clientID))
      setTimeout(() => { resolve(null) }, 1300)
    })
  }

  reachGoal(target, params) {
    this.log(`[YANDEX] reachGoal: ${target}`)
    window.ym(this.yandexMetrikaID, 'reachGoal', target, params)
  }
}
